import '.ev{font-size:1.125rem;}.ssr-plugin'
import '.dv{line-height:1.75rem;}.ssr-plugin'
import '.i2{text-decoration:none;}.ssr-plugin'
import '.g0{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ev dv"
    >
      {translations.privacySubtitle}{' '}
      <a className="i2 g0"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="i2 g0"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
